import { ajaxActions } from './AjaxActions';
import { CategoryDto, PositionDto } from './DocumentT';
import { ToastS } from './ToastS';

const BASE_URL = process.env.REACT_APP_DOCUMENT_SERVICE_URL;
const fetchProducts = async (categoryId?: string): Promise<PositionDto[]> => {
  const res = await ajaxActions.get(`${BASE_URL}/positionFavorites${categoryId ? `?categoryId=${categoryId}` : ''}`);
  if (res.ok) {
    return res.json();
  }
  return [];
};

const addProduct = async (position?: Partial<PositionDto>): Promise<PositionDto | null> => {
  const res = await ajaxActions.put(`${BASE_URL}/positionFavorites`, position ?? {});
  if (res.ok) {
    ToastS.info('product-created', 'Produkt erstellt');
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const editProduct = async (productId: number, patch: Partial<PositionDto>): Promise<PositionDto | null> => {
  const res = await ajaxActions.patch(`${BASE_URL}/positionFavorites/${productId}`, patch);
  if (res.ok) {
    return res.json();
  }
  return null;
};

const deleteProduct = async (productId: number): Promise<boolean> => {
  const res = await ajaxActions.del(`${BASE_URL}/positionFavorites/${productId}`);
  if (res.ok) {
    ToastS.info('product-deleted', 'Produkt gelöscht');
    return true;
  }
  ToastS.generalError();
  return false;
};

const patchPosition = async (positionId: number, patch: Partial<PositionDto>): Promise<PositionDto | null> => {
  const res = await ajaxActions.patch(`${BASE_URL}/positions/${positionId}`, patch);
  if (res.ok) {
    return res.json();
  }
  ToastS.interceptError(res);
  return null;
};

const insertAsProduct = async (position: PositionDto): Promise<PositionDto | null> => {
  const res = await ajaxActions.put(`${BASE_URL}/positionFavorites`, position);
  if (res.ok) {
    ToastS.success('save-favourite', 'Position als Favorit gespeichert.');
    return res.json();
  }
  ToastS.error('save-favourite', 'Position konnte nicht speichert werden');
  return null;
};

// Fetch all categories
const fetchCategories = async (): Promise<CategoryDto[]> => {
  const res = await ajaxActions.get(`${BASE_URL}/categories`);
  if (res.ok) {
    return res.json();
  }
  return [];
};

// Edit category (PATCH)
const editCategory = async (id: string, patch: Partial<CategoryDto>): Promise<CategoryDto | null> => {
  const res = await ajaxActions.patch(`${BASE_URL}/categories/${id}`, patch);
  if (res.ok) {
    return res.json();
  }
  return null;
};

// Move category (PATCH)
const moveCategory = async (id: string, targetId: string): Promise<CategoryDto[] | null> => {
  const res = await ajaxActions.patch(`${BASE_URL}/categories/move/${id}?targetId=${targetId}`, null);
  if (res.ok) {
    return res.json();
  }
  ToastS.generalError();
  return null;
};

// Delete category
const deleteCategory = async (id: string): Promise<boolean> => {
  const res = await ajaxActions.del(`${BASE_URL}/categories/${id}`);
  if (res.ok) {
    ToastS.info('category-deleted', 'Kategorie wurde gelöscht');
    return true;
  }
  ToastS.generalError();
  return false;
};

// eslint-disable-next-line import/prefer-default-export
export const PositionS = {
  fetchProducts,
  addProduct,
  editProduct,
  deleteProduct,
  patchPosition,
  insertAsProduct,
  fetchCategories,
  editCategory,
  moveCategory,
  deleteCategory,
};
